// extracted by mini-css-extract-plugin
export const content = "privacy-module--content--3K5Z1";